export default function getNotificationsPermission() {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ data: "notificationsPermission" }));
  }
}
